export const EBulkActionFeatures = {
  ALLOW: 'ALLOW',
  DENY: 'DENY',
};